import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackForgotPasswordTapped = (track: RedcatAnalyticsStore['track']) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.ForgotPasswordTapped,
    properties: {},
  };

  track(event);
};
